import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const CatalystBoardCorner = () => {
  useEffect(() => {
    document.title =
      "Catalyst Board Corner-  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Catalyst Board Corner-</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Catalyst Board Corner</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board_practical_2025-26.pdf"
                  target="_blank"
                >
                  <b>
                    {" "}
                    Schedule for Board Practical Examination (2025-26) - Class
                    XII{" "}
                  </b>
                </Link>
              </p>

              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/consent_form.pdf"
                  target="_blank"
                >
                  <b>
                    {" "}
                    CONSENT FORM (for early departure after BOARD
                    PRACTICAL){" "}
                  </b>
                </Link>
              </p>

              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Class_XII_Boards_Roll_no.pdf"
                  target="_blank"
                >
                  <b> CLASS XII - BOARD ROLL NUMBERS (2025-26) </b>
                </Link>
              </p>

              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/eng_board_prac_2025-26.pdf"
                  target="_blank"
                >
                  <b> ENG Board Practical 2025-26 </b>
                </Link>
              </p>

              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Guidance_Class_X_Boards_Examinations_09122025.pdf"
                  target="_blank"
                >
                  <b> Guidance to Class X students for Boards Examinations </b>
                </Link>
              </p>
              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Notification_Two_Board_Examinations_Class_X_2026_25062025.pdf"
                  target="_blank"
                >
                  <b> Two Board Examinations in class X from 2026 </b>
                </Link>
              </p>

              <h6>Cbse Datesheet 2026:</h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DATESHEETclassX2026.pdf"
                    target="_blank"
                  >
                    {" "}
                    Class X
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DATESHEETclassXII2026.pdf"
                    target="_blank"
                  >
                    {" "}
                    Class XII
                  </Link>{" "}
                </li>
              </ul>
              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NoticePostResultClassX-XII.pdf"
                  target="_blank"
                >
                  <b> Notice Post Result Declaration Class X & XII </b>
                </Link>
              </p>
              <p>
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/StepwiseUserguide.pdf"
                  target="_blank"
                >
                  <b>
                    {" "}
                    Stepwise User guide to access Class X and XII Marksheets cum
                    Certificate & Migration Certificate after the declaration of
                    result.{" "}
                  </b>
                </Link>
              </p>
              {/*  <h6>Supplementary Datesheet 2025:</h6>
                    <ul className="list mainlist"> 
                       <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SupplementaryclassX2025.pdf" target="_blank">   Class X</Link> </li>
                       <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SupplementaryclassXII2025.pdf" target="_blank">   Class XII</Link> </li>
                   </ul>  
                    
                    <h6>Cbse Datesheet 2025:</h6>
                       <ul className="list mainlist"> 
                          <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DATESHEETclassX2025.pdf" target="_blank">   Class X</Link> </li>
                          <li><Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/DATESHEETclassXII2025.pdf" target="_blank">   Class XII</Link> </li>
  </ul> */}
              <h6>Class XII</h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-eng-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-phy-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physics{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-che-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Chemistry{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-acc-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Accountancy{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-his-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    History{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-psy-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Psychology{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-poliSci-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Political Science{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-BusStu-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Business Studies{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-bio-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Biology{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-math-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Mathematics{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-homeSci-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Home Science{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-Eco-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Economics{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-ComSci-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Computer Science{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-InfoPra-12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Informatics Practices{" "}
                  </Link>
                </li>
              </ul>
              <h6>Class X </h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-eng-10.pdf"
                    target="_blank"
                  >
                    {" "}
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-math-10.pdf"
                    target="_blank"
                  >
                    {" "}
                    Mathematics{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-phy-10.pdf"
                    target="_blank"
                  >
                    Physics
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-che-10.pdf"
                    target="_blank"
                  >
                    {" "}
                    Chemistry{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-bio-10.pdf"
                    target="_blank"
                  >
                    Biology{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-scoSci-10.pdf"
                    target="_blank"
                  >
                    Social Science{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/board-corner-Hindi-10.pdf"
                    target="_blank"
                  >
                    {" "}
                    Hindi{" "}
                  </Link>
                </li>
              </ul>
              <h6>Class XII </h6>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Subject-wiseBoard.pdf"
                  target="_blank"
                >
                  {" "}
                  Cbse Class Xii Subject-wise Board Examination Tips{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/10WaysToBeat.pdf"
                  target="_blank"
                >
                  {" "}
                  10 Ways To Beat Stress{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ScoringWellInEnglish.pdf"
                  target="_blank"
                >
                  {" "}
                  <b> English </b> Scoring Well In English{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/TrendQuestions-physics.pdf"
                  target="_blank"
                >
                  {" "}
                  <b> Physics </b> Latest Trend Questions-physics{" "}
                </Link>{" "}
                ,{" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/WritingSkills-physics.pdf"
                  target="_blank"
                >
                  {" "}
                  Answer Writing Skills-physics{" "}
                </Link>{" "}
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ScoringBiology.pdf"
                  target="_blank"
                >
                  <b>Biology</b> Scoring 100 For Biology
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/StudyPsychology.pdf"
                  target="_blank"
                >
                  <b>Psychology</b> How To Study Psychology?{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InformaticsPractices.pdf"
                  target="_blank"
                >
                  <b>Informatics Practices</b> Guidelines For Informatics
                  Practices Students{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/reparationOfMathematics.pdf"
                  target="_blank"
                >
                  <b>Mathematics</b> Steps For Preparation Of Mathematics{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/GeographyStudents.pdf"
                  target="_blank"
                >
                  <b>Geography</b> Guidelines For Geography Students{" "}
                </Link>
              </p>
              <p>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/StudyChemistry.pdf"
                  target="_blank"
                >
                  <b>Chemistry</b> Tips To Study Chemistry{" "}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CatalystBoardCorner;
